/**
 * Logger conditionnel — silencieux en production.
 *
 * Batch #14.92 — Remplace les `console.*` éparpillés pour éviter le bruit en prod
 * et l'exposition de logs internes dans la console du navigateur du client.
 *
 * Usage :
 *   import { logger } from "@/lib/logger";
 *   logger.info("[push] init OK");      // dev → console, prod → noop
 *   logger.warn("[push] error: ...");   // dev → console.warn, prod → noop
 *   logger.error("Critical: ...");      // toujours loggé (erreurs vraiment critiques)
 *
 * On peut forcer l'activation en prod avec `localStorage.setItem('debug_logs', '1')`.
 */
const isDev = process.env.NODE_ENV !== "production";

function isExplicitDebug() {
  try {
    return typeof window !== "undefined" && window.localStorage?.getItem("debug_logs") === "1";
  } catch {
    return false;
  }
}

function shouldLog() {
  return isDev || isExplicitDebug();
}

export const logger = {
  info: (...args) => { if (shouldLog()) console.info(...args); },
  debug: (...args) => { if (shouldLog()) console.debug(...args); },
  warn: (...args) => { if (shouldLog()) console.warn(...args); },
  // error reste toujours actif — c'est important même en prod
  error: (...args) => { console.error(...args); },
};

export default logger;
